import Proptypes from 'prop-types';
import { useEffect, useState } from 'react';

import { ImTable2 } from 'react-icons/im';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui';

import { useBubbleTiptap } from '../bubble/Bubble';

import FormatterIcon from './FormatterIcon';

export default function TableFormatters({ editor, tooltipText }) {
  const { setBubblePopover } = useBubbleTiptap()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setBubblePopover && setBubblePopover(open)
  }, [open, setBubblePopover])

  return <DropdownMenu open={open} onOpenChange={setOpen}>
    <DropdownMenuTrigger>
      <FormatterIcon active={editor.isActive('table')} icon={ImTable2} tooltipText={tooltipText} />
    </DropdownMenuTrigger>
    <DropdownMenuContent className='p-0'>
      <DropdownMenuItem onClick={() => {
        editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
      }}>
        Insert table
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().addColumnBefore().run()}>
        Add column before
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().addColumnAfter().run()}>Add column after</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().deleteColumn().run()}>Delete column</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().addRowBefore().run()}>Add row before</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().addRowAfter().run()}>Add row after</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().deleteRow().run()}>Delete row</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().deleteTable().run()}>Delete table</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().mergeCells().run()}>Merge cells</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().splitCell().run()}>Split cell</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().toggleHeaderColumn().run()}>
        Toggle header column
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().toggleHeaderRow().run()}>
        Toggle header row
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().toggleHeaderCell().run()}>
        Toggle header cell
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().mergeOrSplit().run()}>Merge or split cell</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().setCellAttribute('colspan', 2).run()}>
        Set cell attribute
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().fixTables().run()}>Fix tables</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().goToNextCell().run()}>Go to next cell</DropdownMenuItem>
      <DropdownMenuItem onClick={() => editor.chain().focus().goToPreviousCell().run()}>
        Go to previous cell
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
}

TableFormatters.propTypes = {
  editor: Proptypes.object,
}
